import React from "react";
import PageHeader from "../../PageHeader";
import { ReactComponent as SubjectIcon } from "../../../images/subjectimage/subjecticon.svg";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import useStyles from "../../../../styles";
import ViewAllocatedCenter from "./ViewAllocatedCenterForm";
import { toast } from "react-toastify";
import bulkAllocateCenter from "../../../../center.csv"

function AllocatedCenter() {
  const classes = useStyles();

   const handleDownload = () => {
        const link = document.createElement("a");
        link.href = bulkAllocateCenter;
        link.setAttribute("download", "centersInBulk.csv");
    
        // Append to the document and trigger the download
        document.body.appendChild(link);
        link.click();
    
        // Check if the download started (link exists in document)
        if (document.body.contains(link)) {
          toast.success("Sample file for adding learners in bulk has been downloaded");
        } else {
          toast.error("Failed to download the bulk learners file. Please try again.");
        }
    
        // Clean up
        link.parentNode.removeChild(link);
      };
  const Heading = [
    {
      id: 1,
      pageicon:<SubjectIcon />,
      mainheading: "Center",
      downloadlink: "Download bulk Sample Files",
      onDownload: handleDownload,
      subhead: "Want to Add in Bulk ?",
      addbtntext:"New Center",
      addbtnicon: <AddIcon />,
      addbtnstyle: "bluebtn",
      path:"/admin/addallocatedcenter",
      showDownloadButton: true,
    },
  ];
  return (
    <div className={`${classes.p1} ${classes.pb0}`}>
      <PageHeader Heading={Heading}/>
      <ViewAllocatedCenter/>
    </div>
  );
}
export default AllocatedCenter;